export default "__VITE_ASSET__e42305bf__"